import { render, staticRenderFns } from "./trendsArrowIcon.vue?vue&type=template&id=791c5f1a&"
import script from "./trendsArrowIcon.vue?vue&type=script&lang=js&"
export * from "./trendsArrowIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports